export default {
      id: "pattern-plus-right-cropped-3-usage",
      viewBox: "0 0 157 158",
      url: "../icon/" + "icons.svg#pattern-plus-right-cropped-3-usage",
      toString: function () {
        return this.url;
      }
    }